module.exports = __webpack_public_path__ + "img/visa001.37a91382.jpg";